// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"18241045f6c0df1fa33f","293":"2e0158625154aac3a29b","518":"f7cc1fb3056ce2709b4d","779":"9c8a567b1fce4563eb83"}[chunkId] + ".js";
};